import React, { useEffect, useState } from "react";
import "./header.css";
import { useNavigate } from "react-router-dom";
import { DummyProfile } from "../../assets";
import service from "../../service/service";

const Header = ({ onToggle }) => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    service.get("users/profile-detail", {}, { skipToast: true })
      .then((response) => setProfile(response?.data?.data || response?.data || null))
      .catch(() => {});
  }, []);

  return (
    <header className="top-header">
      {/* LEFT */}
      <div className="header-left">
        <button
          className="hamburger-btn"
          type="button"
          onClick={onToggle}
          aria-label="Toggle navigation menu"
        >
          <span aria-hidden="true">&#9776;</span>
        </button>

      </div>

      {/* RIGHT */}
      <div className="header-right">
        {/* <button className="notification-btn">
           <img src={notificationBell} alt="notification bell" className="img-fluid"/>
        </button> */}
    

        <button className="headerProfileButton" onClick={() => navigate("/profile")}>
          <img src={profile?.profile_pic || profile?.profile_image || DummyProfile} alt="profile" className="profile-img" />
          <p>{profile?.name || "Profile"}</p>
        </button>
      </div>
    </header>
  );
};

export default Header;
